import ButtonBase from 'components/partials/button'
import InputBase from 'components/partials/inputBase'
import React, { useEffect, useState } from 'react'
import { IAgencyGroup, IAgencyGroupJobConfig, IEmailManagementConfig } from '../../interface'
import CustomTemplateForStage from '../components/customTemplate'
import { isNumber } from 'lodash'

interface Props {
  agencyGroup: IAgencyGroup
  agencyGroupJobConfigs: IAgencyGroupJobConfig[]
  handleChangeEditMode: (isEdit: boolean) => void
  refetchDetailData: () => void
}

const ViewTemplateCustomization: React.FC<Props> = ({
  agencyGroup,
  handleChangeEditMode,
  agencyGroupJobConfigs,
}) => {
  const [currentAgencyGroup, setCurrentAgencyGroup] = useState<IAgencyGroup>(agencyGroup)
  const [currentEmailConfig, setCurrentEmailConfig] = useState<IEmailManagementConfig | null>()
  const [customConfigs, setCustomConfigs] =
    useState<IAgencyGroupJobConfig[]>(agencyGroupJobConfigs)

  const onEditBtn = () => {
    handleChangeEditMode(true)
  }

  useEffect(() => {
    if (agencyGroup?.agencyGroupId) {
      setCurrentAgencyGroup(agencyGroup)
    }
  }, [agencyGroup])

  useEffect(() => {
    if (agencyGroupJobConfigs && agencyGroupJobConfigs.length > 0) {
      const emailConfig = agencyGroupJobConfigs[0].subEmailManagementConfig?.emailManagementConfig
      if (emailConfig) {
        setCurrentEmailConfig(emailConfig)
      }
      const configs = agencyGroupJobConfigs.map((item) => ({
        ...item,
        index: item.agencyGroupJobConfigId,
      }))

      setCustomConfigs(configs)
    } else {
      //  New || empty data
      setCurrentEmailConfig(null)
      setCustomConfigs([])
    }
  }, [agencyGroupJobConfigs])

  if (!currentAgencyGroup) return null

  return (
    <div className="flex flex-col space-y-2">
      <div className="flex justify-end">
        <ButtonBase onClick={onEditBtn}>{currentEmailConfig ? 'Edit' : 'Add'}</ButtonBase>
      </div>

      <div className="w-full">
        {currentEmailConfig && (
          <InputBase
            name={`view-email-config-${currentEmailConfig.emailManagementConfigId}`}
            className="w-full text-ellipsis"
            value={`${currentEmailConfig.startSubject} - ${currentEmailConfig.cancelSubject}`}
            disable={true}
          />
        )}
      </div>

      {customConfigs && (
        <div className="w-full space-y-2">
          {customConfigs.map((item) => {
            if (isNumber(item.index))
              return (
                <CustomTemplateForStage
                  key={`view-custom-email-template-${item.index}`}
                  config={item}
                  isEditMode={false}
                  subEmailConfigs={currentEmailConfig?.subEmailManagementConfig ?? []}
                />
              )
          })}
        </div>
      )}
    </div>
  )
}

export default ViewTemplateCustomization
